import { cn } from "@/lib/utils";

export type DestinyTheme = {
  number: number;
  name: string;
  gradient: string;
  softBg: string;
  ring: string;
  text: string;
  badge: string;
};

const THEMES: Record<number, Omit<DestinyTheme, "number">> = {
  1: {
    name: "Kırmızı",
    gradient: "from-red-500/20 via-red-500/10 to-transparent",
    softBg: "bg-red-500/10",
    ring: "ring-red-500/25",
    text: "text-red-600 dark:text-red-400",
    badge: "bg-red-500 text-white",
  },
  2: {
    name: "Turuncu",
    gradient: "from-orange-500/20 via-orange-500/10 to-transparent",
    softBg: "bg-orange-500/10",
    ring: "ring-orange-500/25",
    text: "text-orange-600 dark:text-orange-400",
    badge: "bg-orange-500 text-white",
  },
  3: {
    name: "Sarı",
    gradient: "from-yellow-400/25 via-yellow-400/10 to-transparent",
    softBg: "bg-yellow-400/10",
    ring: "ring-yellow-400/25",
    text: "text-yellow-700 dark:text-yellow-400",
    badge: "bg-yellow-400 text-black",
  },
  4: {
    name: "Yeşil",
    gradient: "from-emerald-500/20 via-emerald-500/10 to-transparent",
    softBg: "bg-emerald-500/10",
    ring: "ring-emerald-500/25",
    text: "text-emerald-600 dark:text-emerald-400",
    badge: "bg-emerald-500 text-white",
  },
  5: {
    name: "Mavi",
    gradient: "from-sky-500/20 via-sky-500/10 to-transparent",
    softBg: "bg-sky-500/10",
    ring: "ring-sky-500/25",
    text: "text-sky-600 dark:text-sky-400",
    badge: "bg-sky-500 text-white",
  },
  6: {
    name: "İndigo",
    gradient: "from-indigo-500/20 via-indigo-500/10 to-transparent",
    softBg: "bg-indigo-500/10",
    ring: "ring-indigo-500/25",
    text: "text-indigo-600 dark:text-indigo-400",
    badge: "bg-indigo-500 text-white",
  },
  7: {
    name: "Mor",
    gradient: "from-violet-500/20 via-violet-500/10 to-transparent",
    softBg: "bg-violet-500/10",
    ring: "ring-violet-500/25",
    text: "text-violet-600 dark:text-violet-400",
    badge: "bg-violet-500 text-white",
  },
  8: {
    name: "Pembe",
    gradient: "from-pink-500/20 via-pink-500/10 to-transparent",
    softBg: "bg-pink-500/10",
    ring: "ring-pink-500/25",
    text: "text-pink-600 dark:text-pink-400",
    badge: "bg-pink-500 text-white",
  },
  9: {
    name: "Altın",
    gradient: "from-amber-400/25 via-amber-400/10 to-transparent",
    softBg: "bg-amber-400/10",
    ring: "ring-amber-400/25",
    text: "text-amber-700 dark:text-amber-300",
    badge: "bg-amber-400 text-black",
  },
};

export function getDestinyTheme(destinyNumber: number): DestinyTheme {
  const key = Math.round(destinyNumber);
  const entry = THEMES[key] ?? THEMES[1];
  return { number: key >= 1 && key <= 9 ? key : 1, ...entry };
}

export function themedPanelClass(destinyNumber: number, className?: string) {
  const theme = getDestinyTheme(destinyNumber);
  return cn(
    "relative overflow-hidden rounded-2xl border bg-card/70 shadow-sm ring-1",
    theme.ring,
    className,
  );
}
